import React, { useMemo } from "react";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./checkoutForm";

/**
 * Stable Stripe Elements wrapper — avoids remounting Payment Element when parent re-renders.
 */
export default function StripeCheckoutElements({
  stripePromise,
  clientSecret,
  checkoutFormProps,
}) {
  const options = useMemo(
    () =>
      clientSecret
        ? {
            clientSecret,
            appearance: { theme: "stripe" },
          }
        : null,
    [clientSecret]
  );

  if (!clientSecret || !options || !stripePromise) {
    return (
      <p className="text-muted small text-center mb-0">
        Payment form is loading…
      </p>
    );
  }

  return (
    <Elements stripe={stripePromise} options={options} key={clientSecret}>
      <CheckoutForm {...checkoutFormProps} />
    </Elements>
  );
}
